import { createContext, useContext, useState } from "react";
import * as XLSX from "xlsx";

// Internal Imports
import { getError, getFile, openNotification } from "../common/constants/Utilities";
import useListAttribute from "../hooks/useListAttribute";
import { IAnswerEntitySelected, IFormAnswer } from "../interfaces/IAnswer";
import { IEntitySurvey } from "../interfaces/IEntitySurvey";
import { IForm, IFormQuestionOption } from "../interfaces/IForm";
import IFormContext from "../interfaces/IFormContext";
import { IListBase, IListDetail } from "../interfaces/IListado";
import { IQuestion } from "../interfaces/IQuestion";
import { ISurvey } from "../interfaces/ISurvey";
import { IUserInformation } from "../interfaces/IUser";
import { GetListBaseDetailByID } from "../services/list";



// Provider's Properties
interface Props {
    children: any;
}

// Context
const FormContext = createContext<IFormContext>({
    // USER FORM
    userInformationForm: undefined,
    setUserInformationForm: () => { },
    userNameCreation: '',
    setUserNameCreation: () => "",
    statusUserForm: false,
    setStatusUserForm: () => { },

    // LISTADO CLIENTE FORM
    listBaseForm: undefined,
    setListBaseForm: () => { },
    statusListBaseForm: false,
    setStatusListBaseForm: () => { },
    // STEP 3
    loadingExcel: false,
    setLoadingExcel: () => { },
    downLoadExcelFromDTO: () => { },
    convertIListDetail: () => [],

    // FORMQUESTION FORM
    formQuestion: undefined,
    setFormQuestion: () => { },
    statusFormQuestion: false,
    setStatusFormQuestion: () => { },

    // FORMS
    loadingSubmit: false,
    setLoadingSubmit: () => { },

    // FORMID SELECTED
    formIdSelected: undefined,
    setFormIdSelected: () => { },

    // FORMHISTORICID SELECTED
    answerEntitySelected: undefined,
    setAnswerEntitySelected: () => { },

    //Question Form
    questionForm: undefined,
    setQuestionForm: () => { },

    // Formulario Listado DetalleID
    entitySurveySelected: undefined,
    setEntitySurveySelected: () => { },

    //Respuesta Opcion selecionada
    optionSelected: undefined,
    setOptionSelected: () => { },

    //Formulario respondido
    formAnswer: undefined,
    setFormAnswer: () => { },

    //Varibale global para pasar datos.
    AnswerIdSelected: undefined,
    setAnswerIdSelected: () => { }

})


const FormProvider: React.FC<Props> = ({ children }) => {

    // States
    const { listAttribute } = useListAttribute();

    // USER FORM
    const [userInformationForm, setUserInformationForm] = useState<IUserInformation>();
    const [userNameCreation, setUserNameCreation] = useState<string>("");
    const [statusUserForm, setStatusUserForm] = useState<boolean>(false);

    // LISTADO CLIENTE FORM
    const [listBaseForm, setListBaseForm] = useState<IListBase>();
    const [statusListBaseForm, setStatusListBaseForm] = useState<boolean>(false);
    // STEP 3
    const [loadingExcel, setLoadingExcel] = useState<boolean>(false);


    // LISTADO FORMQUESTION FORM
    const [formQuestion, setFormQuestion] = useState<IForm>();
    const [statusFormQuestion, setStatusFormQuestion] = useState<boolean>(false);

    // FORMS
    const [loadingSubmit, setLoadingSubmit] = useState<boolean>(false);

    // FORMID SELECTED
    const [formIdSelected, setFormIdSelected] = useState<number>();


    // FORMIDHISTORIC SELECTED
    const [answerEntitySelected,setAnswerEntitySelected] = useState<IAnswerEntitySelected>();

    //Question Form
    const [questionForm, setQuestionForm] = useState<ISurvey>()

    // Formulario Listado DetalleID
    const [entitySurveySelected, setEntitySurveySelected] = useState<IEntitySurvey>();
    const [optionSelected, setOptionSelected] = useState<IFormQuestionOption>();

    //Formulario respondido
    const [formAnswer, setFormAnswer] = useState<IFormAnswer>();

    //Varibale global para pasar datos.
    const [AnswerIdSelected, setAnswerIdSelected] = useState<any>();



    // METHODS
    const convertIListDetail = (data: IListDetail[]): any[] => {
        const resultList: any[] = [];
        data.forEach((x) => {
            const detailMapped: any = {
                codigo: x.codigo,
                nombre: x.nombre,
                latitud: x.latitud,
                longitud: x.longitud,
                telefono1: x.telefono1,
                telefono2: x.telefono2,
                telefono3: x.telefono3,
                orden: x.orden
            };

            x.listadoDetalleAtributo?.forEach((y, indexY) => {
                let nombreAttr = !!listAttribute.find(x => x.atributoGUID === y.atributoGUID)?.nombre
                    ? listAttribute.find(x => x.atributoGUID === y.atributoGUID)!.nombre
                    : `atributo${indexY + 1}`;

                detailMapped[nombreAttr] = y.atributoValor;
            })
            resultList.push(detailMapped);
        })

        return resultList;
    }

    const downLoadExcelFromDTO = (listadoID: number) => {
        setLoadingExcel(true);
        GetListBaseDetailByID(listadoID)
            .then(({ data }) => {
                //console.log(data);
                const resultMapped = convertIListDetail(data);
                let sheet: any;
                sheet = XLSX.utils.json_to_sheet(resultMapped);
                getFile(sheet);
            })
            .catch((response) => {
                openNotification('error', 'Error', getError(response?.msg));
            })
            .finally(() => {
                setLoadingExcel(false);
            })
    }
    

    return (
        <FormContext.Provider
            value={{
                // USER FORM
                userInformationForm,
                setUserInformationForm,
                userNameCreation,
                setUserNameCreation,
                statusUserForm,
                setStatusUserForm,

                // LISTADO CLIENTE FORM
                listBaseForm,
                setListBaseForm,
                statusListBaseForm,
                setStatusListBaseForm,
                //STEP3
                loadingExcel,
                setLoadingExcel,
                downLoadExcelFromDTO,
                convertIListDetail,

                // QUESTIONFORM FORM
                formQuestion,
                setFormQuestion,
                statusFormQuestion,
                setStatusFormQuestion,

                // Form
                loadingSubmit,
                setLoadingSubmit,

                // FORMID SELECTED
                formIdSelected,
                setFormIdSelected,

                // FORMHISTORICID SELECTED
                answerEntitySelected,
                setAnswerEntitySelected,

                //Question Form
                questionForm,
                setQuestionForm,

                // Formulario Listado DetalleID
                entitySurveySelected,
                setEntitySurveySelected,

                //Opcion Respuesta selecionada
                optionSelected,
                setOptionSelected,

                //Formulario respondido
                formAnswer,
                setFormAnswer,


                //Varibale global para pasar datos.
                AnswerIdSelected,
                setAnswerIdSelected,

            }}
        >
            {children}
        </FormContext.Provider>
    )
}

export const useForm = () => {
    const context = useContext(FormContext);
    return context;
}

export default FormProvider;